export const ApiConfigs = {
  splitCollectionIntoQuery: (collection: any[], collectionName: string) => {
    return collection.reduce((g: any, name: any) => {
      g += `${collectionName}=${name}&`;
      return g;
    }, '');
  },
};
